import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация тестового сервера, он же Staging
 */
class EnvironmentAdminTest extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  enableWorkflowButton = false;
  serverPicturesPath = 'https://dtm.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://dtm.compo-soft.ru/documents';
  serverApi =  'https://dtm.compo-soft.ru/api/v1';
  serverUrl =  'https://dtm.compo-soft.ru';
  impersonate = false;
  // Корень, а не `/cabinet/dashboard` (SEO-8) — разбор в базовом `Environment.ts`.
  impersonatePortalPath = 'https://dtm.compo-soft.ru/';
  accessRolesCatalog = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
  publicShowcase = true;
  commonFeatureGroup = true;
}

export const environment = new EnvironmentAdminTest();
